import React from 'react';

const SafeIcon = ({ icon, className = "", ...props }) => {
  // Simple pass-through for emojis/text
  return (
    <span 
      className={`inline-flex items-center justify-center not-italic leading-none ${className}`} 
      {...props} 
      role="img" 
      aria-hidden="true"
    >
      {icon || '❓'}
    </span>
  );
};

export default SafeIcon;